module.exports = __webpack_public_path__ + "static/media/DRGIcon_MiniSet.a5fcd6d5.png";